<template>
  <f-dashboard-content-wrapper>
    <suspense>
      <template #default>
        <router-view></router-view>
      </template>
      <template #fallback>
        Chargement...
      </template>
    </suspense>
  </f-dashboard-content-wrapper>
</template>
